import axios from "axios";

export const isCoreRequest = (config, coreBaseUrl = process.env.REACT_APP_BASE_URL) => {
  if (!coreBaseUrl || !config?.url) return false;

  try {
    const pageUrl = window.location.href;
    const coreUrl = new URL(coreBaseUrl, pageUrl);
    const requestUrl = new URL(axios.getUri(config), pageUrl);
    const corePath = coreUrl.pathname.replace(/\/+$/, "");

    return (
      ["http:", "https:"].includes(coreUrl.protocol) &&
      requestUrl.origin === coreUrl.origin &&
      !requestUrl.username &&
      !requestUrl.password &&
      (requestUrl.pathname === corePath ||
        requestUrl.pathname.startsWith(`${corePath}/`))
    );
  } catch (_) {
    return false;
  }
};
